export enum VendorType {
  TODOS = 'O',
  CRISTALES = 'C',
  RUEDAS = 'R',
  LIQUIDADORES = 'L',
  INSPECTORES = 'I',
  INVESTIGADORES = 'V',
  RUEDAS_Y_CRISTALES = 'A',
  TALLER = 'T',
}

export const VendorTypeDescription: Record<VendorType, string> = {
  [VendorType.TODOS]: 'TODOS',
  [VendorType.CRISTALES]: 'PROVEEDOR REPOSICION DE CRISTALES',
  [VendorType.RUEDAS]: 'PROVEEDOR REPOSICION DE RUEDAS',
  [VendorType.LIQUIDADORES]: 'LIQUIDADORES DE SINIESTROS',
  [VendorType.INSPECTORES]: 'INSPECTORES DE SINIESTROS',
  [VendorType.INVESTIGADORES]: 'INVESTIGADORES DE SINIESTROS',
  [VendorType.RUEDAS_Y_CRISTALES]: 'PROVEEDOR DE RUEDAS Y/O CRISTALES',
  [VendorType.TALLER]: 'TALLER',
};